import { root } from 'postcss';

export default (initialShow) => ({
	isShown: initialShow,
	cache: {
		root: null,
	},
	updateHeight() {
		if (this.cache.root) {
			this.cache.root.style.setProperty(
				'--announcement-height',
				this.$el.offsetHeight / 16 + 'rem'
			);
		}
	},
	setShown(show) {
		this.isShown = show;
		this.$nextTick(() => this.updateHeight());
	},
	init() {
		this.cache.root = document.querySelector(':root');
		this.$nextTick(this.updateHeight());
	},
	main: {
		['@resize.window.throttle.500ms.debounce.500ms']() {
			this.updateHeight();
		},
		['x-show']() {
			return this.isShown;
		},
	},
});
